function c(s, n) {
  return s && Object.keys(s ?? {}).reduce((t, b) => {
    const e = b, r = s[e];
    return typeof r == "string" && r.substring(0, 1) === "$" && n[r.substring(1)] ? (t[e] = n[r.substring(1)], t) : (t[e] = r, t);
  }, {});
}
export {
  c as resolveParams
};
